import Vue from 'vue'
import type { Route, RouteConfig } from 'vue-router'
import VueRouter from 'vue-router'
import type { Position, PositionResult } from 'vue-router/types/router'
import goTo from 'vuetify/lib/services/goto'
import type { VuetifyGoToTarget } from 'vuetify/types/services/goto'

import { useNotifications } from '@/store/notifications/use'

const dummy = () => import('@/pages/dummy.vue')

const routes: Array<RouteConfig> = []

// if is mobile
if (import.meta.env.VITE_IS_MOBILE === '1') {
  routes.push(
    {
      path: '/',
      component: () => import('@/pages/mobile/index.vue'),
      meta: {
        title: 'Accueil',
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/pages/mobile/home.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/mobile/login.vue'),
      meta: {
        title: 'Connexion',
        allowAnonymous: true,
      },
    },
    {
      path: '/login/workspace',
      name: 'LoginWorkspace',
      component: () => import('@/pages/mobile/workspace.vue'),
      meta: {
        title: 'Espace de travail',
        allowAnonymous: true,
      },
    },
    {
      path: '/database-manager',
      name: 'DatabaseManager',
      component: () => import('@/pages/mobile/database-manager.vue'),
      meta: {
        title: 'Gestionnaire de base de donnée',
      },
    },
    {
      path: '/forms',
      name: 'Forms',
      component: () => import('@/pages/mobile/forms.vue'),
      meta: {
        title: 'Liste des formulaires',
      },
    },
    {
      path: '/form/:id',
      name: 'FormEdition',
      component: () => import('@/pages/mobile/forms/edit.vue'),
      meta: {
        title: 'Edition',
      },
    },
    {
      path: '/create/:id',
      name: 'FormCreation',
      component: () => import('@/pages/mobile/forms/create.vue'),
      meta: {
        title: 'Création',
      },
    },
  )
}
else {
  routes.push(
    {
      path: '/',
      component: () => import('@/pages/index.vue'),
      meta: {
        title: 'Accueil',
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/pages/home.vue'),
        },
        {
          path: '/list/:isa/:kid?',
          name: 'Liste',
          component: () => import('@/pages/list.vue'),
          meta: {
            title: 'Liste',
          },
        },
      ],
    },
    // Login ---------------------------------------------------------------------
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/index.vue'),
      meta: {
        title: 'Connexion',
        allowAnonymous: true,
      },
    },
    {
      path: '/login/workspace',
      name: 'LoginWorkspace',
      component: () => import('@/pages/login/workspace.vue'),
      meta: {
        title: 'Espace de travail',
        allowAnonymous: true,
      },
    },
    // Dummy ---------------------------------------------------------------------
    {
      path: '/account',
      name: 'Account',
      component: () => import('@/pages/account.vue'),
      meta: {
        title: 'Mon compte',
      },
    },
    // Admin ---------------------------------------------------------------------
    {
      path: '/admin/oo/:id',
      name: 'AdminOO',
      component: () => import('@/pages/admin/oo/_id.vue'),
      meta: {
        title: 'Administration',
      },
    },
    {
      path: '/admin/upload',
      name: 'AdminUpload',
      component: () => import('@/pages/admin/upload/index.vue'),
      meta: {
        title: 'Administration import de fichiers',
      },
    },
    {
      path: '/admin/class-designer',
      name: 'AdminClassDesigner',
      component: () => import('@/pages/admin/class-designer/index.vue'),
      meta: {
        title: 'Créateur de classes',
      },
    },
    {
      path: '/admin/class-designer/new',
      name: 'AdminClassDesignerNew',
      component: () => import('@/pages/admin/class-designer/new.vue'),
      meta: {
        title: 'Créateur de classes',
      },
    },
    {
      path: '/admin/class-designer/edit/:id',
      name: 'AdminClassDesignerEdit',
      component: () => import('@/pages/admin/class-designer/edit/_id.vue'),
      meta: {
        title: 'Créateur de classes',
      },
    },
    // Form builder ---------------------------------------------------------------------
    {
      path: '/form-builder',
      name: 'Formbuilder',
      component: dummy,
      meta: {
        title: 'Créateur de formulaires',
      },
    },
    // Import en masse ---------------------------------------------------------------------
    {
      path: '/importfile',
      component: () => import('@/pages/importfile.vue'),
      meta: {
        title: 'Import de masse',
      },
      children: [
        {
          path: '',
          name: 'ImportFile',
          redirect: 'dashboard',
        },
        {
          path: 'dashboard',
          component: () => import('@/pages/importfile-dashboard.vue'),
          meta: {
            title: 'Import de masse',
          },
          children: [
            {
              name: 'ImportFileDashboard',
              path: '',
              redirect: 'datasources',
            },
            {
              path: 'datasources',
              name: 'ImportFileDashboardDatasource',
              component: () => import('@/pages/importfile-datasource.vue'),
              meta: {
                title: 'Import de masse',
              },
            },
            {
              path: 'templates',
              name: 'ImportFileDashboardTemplates',
              component: () => import('@/pages/importfile-templates.vue'),
              meta: {
                title: 'Import de masse',
              },
            },
            {
              path: 'integrations',
              name: 'ImportFileDashboardIntegrations',
              component: () => import('@/pages/importfile-integrations.vue'),
              meta: {
                title: 'Import de masse',
              },
            },
          ],
        },
        {
          path: 'templates/new',
          name: 'ImportFileTemplatesNew',
          component: () => import('@/pages/importfile-new.vue'),
          meta: {
            title: 'Import de masse',
          },
        },
        {
          path: 'templates/edit/:id',
          name: 'ImportFileTemplatesEdit',
          component: () => import('@/pages/importfile-edit.vue'),
          meta: {
            title: 'Import de masse',
          },
        },
        {
          path: 'executions',
          name: 'ImportFileExecutionList',
          component: () => import('@/pages/importfileV4/execution-list.vue'),
          meta: {
            title: 'Import de masse',
          },
        },
      ],
    },

    {
      path: '/importfile/assistant',
      name: 'ImportAssistant',
      component: () => import('@/pages/importfileV4/assistant.vue'),
      meta: {
        title: 'Import de masse',
      },
    },
    {
      path: '/support/:id',
      name: 'Support',
      component: () => import('@/pages/support/_id.vue'),
      meta: {
        title: 'Support',
      },
    },
    // UI Builder --------------------------------------------------------------
    {
      path: '/uibuilder',
      name: 'UIBuilder',
      component: () => import('@/pages/uibuilder/index.vue'),
      meta: {
        title: 'UI Builder',
      },
    },
    {
      path: '/uibuilder/view',
      name: 'UI Builder View',
      component: () => import('@/pages/uibuilder/PageBuilder.vue'),
      meta: {
        title: 'UI Builder',
      },
    },
    {
      path: '/uibuilder/edit/:id?',
      name: 'UI Builder Edit',
      component: () => import('@/pages/uibuilder/builder.vue'),
      meta: {
        title: 'UI Builder',
      },
    },
    // Viewer ------------------------------------------------------------------
    {
      path: '/pages/:page',
      name: 'ui-viewer',
      component: () => import('@/pages/pages/_page.vue'),
      meta: {
        title: 'Page',
      },
    },
    // Calendar -----------------------------------------------------------------
    {
      path: '/calendar',
      name: 'Calendar',
      component: () => import('@/pages/calendar.vue'),
      meta: {
        title: 'Calendrier',
      },
    },
    {
      path: '/admin/batch',
      name: 'Batch',
      component: () => import('@/pages/batch.vue'),
      meta: {
        title: 'Batch',
      },
    },
    // Forms
    {
      path: '/form/:id',
      name: 'FormEdition',
      component: () => import('@/pages/form/edit.vue'),
      meta: {
        title: 'Edition',
      },
    },
    {
      path: '/create/:id',
      name: 'FormCreation',
      component: () => import('@/pages/form/create.vue'),
      meta: {
        title: 'Création',
      },
    },
    {
      path: '/notifications/edit/:id',
      name: 'NotificationsEdit',
      component: () => import('@/pages/notifications.vue'),
      meta: {
        title: 'Notification',
      },
    },
    {
      path: '/notifications/new',
      name: 'NotificationsNew',
      component: () => import('@/pages/notifications.vue'),
      meta: {
        title: 'Notification',
      },
    },
    {
      path: '/notifications/list',
      name: 'NotificationsList',
      component: () => import('@/pages/notification-list.vue'),
      meta: {
        title: 'Notification',
      },
    },
    {
      path: '/e-sign/:kid',
      name: 'Signature électonique',
      component: () => import('@/pages/e-sign.vue'),
      meta: {
        title: 'Signature électonique',
      },
    },

    {
      path: '/aktivnote',
      name: 'AKtivnote',
      redirect: {
        name: 'AKtivnoteNote',
      },
    },
    {
      path: '/aktivnote/matrix',
      name: 'AKtivnoteEisenhowerMatrix',
      component: () => import('@/pages/aktivnote/eisenhower-matrix.vue'),
      meta: {
        title: 'Matrice AKtivnote',
      },
    },
    {
      path: '/aktivnote/note',
      name: 'AKtivnoteNote',
      component: () => import('@/pages/aktivnote.vue'),
      meta: {
        title: 'AKtivnote',
      },
    },
    {
      path: '/aktivnote/list/:type/:selectedKid?',
      name: 'AKtivnoteList',
      component: () => import('@/pages/aktivnote/list.vue'),
      meta: {
        title: 'AKtivnote',
      },
    },
    {
      path: '/meet/:id',
      name: 'Meet',
      component: () => import('@/pages/meet.vue'),
      meta: {
        title: 'Meet',
      },
    },
    {
      path: '/chat/:id',
      name: 'Chat',
      component: () => import('@/pages/chat.vue'),
      meta: {
        title: 'Chat',
      },
    },
    {
      path: '/replay',
      name: 'Replay',
      component: () => import('@/pages/replayer.vue'),
      meta: {
        title: 'Replay',
      },
    },
    {
      name: 'Front4',
      path: '/front4/:url(.*)?',
      beforeEnter: (to) => {
        let v4URL = to.params.url ?? '/' // root v4 otherwise
        if (v4URL[0] !== '/') {
          v4URL = `/${v4URL}`
        }
        window.location.assign(v4URL)
      },
    },
  )
}

if (!import.meta.env.PROD) {
  // Dev ---------------------------------------------------------------------
  routes.push({
    path: '/dev',
    name: 'Dev',
    component: () => import('@/pages/dev.vue'),
    meta: {
      title: 'Dev',
    },
    children: [
      {
        name: 'Dev XXX',
        path: ':id',
        component: () => {
          return import('@/pages/dev/index.vue')
        },
        meta: {
          title: 'Dev',
        },
      },
    ],
  })
  routes.push({
    path: '/websocket-debug',
    name: 'WebsocketDebug',
    component: () => import('@/pages/websocket-debug.vue'),
    meta: {
      title: 'Websocket debug',
    },
  })
}

const AuthedRoutes: RouteConfig = {
  path: '/',
  component: () => import('../components/AuthProvider.vue'),
  children: routes,
} satisfies RouteConfig

const BaseRoutes: Array<RouteConfig> = [
  AuthedRoutes,
  // 404 ---------------------------------------------------------------------
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/404.vue'),
    meta: {
      title: 'Page inconnue',
    },
  },
]

export const createRouter = () => {
  Vue.use(VueRouter)

  const router = new VueRouter({
    mode: 'history',
    base: import.meta.env.VITE_FRONT5_BASE_URL,
    scrollBehavior: async (
      to: Route,
      _from: Route,
      savedPosition: void | Position,
    ): Promise<PositionResult> => {
      // https://v2.vuetifyjs.com/features/scrolling/#router3067306e4f7f7528
      let scrollTo: VuetifyGoToTarget = 0

      if (to.hash) {
        scrollTo = to.hash
      }
      else if (savedPosition) {
        scrollTo = savedPosition.y
      }

      return {
        x: 0,
        y: await goTo(scrollTo, {
          duration: 1000,
          easing: 'easeInOutCubic',
        }),
      }
    },
    routes: BaseRoutes,
  })

  // Set meta
  router.beforeEach((to, from, next) => {
    if (!to.meta) {
      to.meta = {}
    }
    document.title = to.meta.title ?? 'Knitiv'
    next()
  })

  // Auth
  // router.beforeEach((to, from, next) => Auth(to, from, next))

  return router
}
